"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleTextWrapper = exports.StyledFontFamilyToggleContainer = exports.StyledDropdownItemWrapper = exports.StyledDropdownTextContainer = exports.StyledDropdownContainer = exports.StyledButtonWrapper = exports.StyledSearchContainer = exports.StyledTitleContainer = exports.StyledFontsContainer = exports.StyledContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
exports.StyledFontsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden auto;
  height: 100%;
  ${({ theme }) => theme.Scrollbar.Default}
`;
exports.StyledTitleContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)}
    ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledSearchContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}
    ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} 0;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledButtonWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.StyledDropdownContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;

  cursor: pointer;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};
  background-color: ${({ theme, selected }) => selected && theme.Color.System.Lightest};

  &:hover {
    background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  }
`;
exports.StyledDropdownTextContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}
    ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
`;
exports.StyledDropdownItemWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  cursor: pointer;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};

  &:hover {
    background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  }
`;
exports.StyledFontFamilyToggleContainer = styled_components_1.default.div `
  display: flex;
  width: 158px;
  cursor: pointer;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  border: 1px solid
    ${({ theme, isSectionVisible }) => isSectionVisible
    ? theme.Color.Brand.Primary
    : theme.Color.Neutrals.Border};
  align-items: center;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)}
    ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  justify-content: space-between;
  transition: all ${({ theme }) => theme.Transition.Timing.In};

  &:hover {
    border-color: #536aed;
    transition: all ${({ theme }) => theme.Transition.Timing.In};

    & span {
      color: #536aed;
    }

    & svg {
      color: #536aed;
      fill: #536aed;
    }
  }
`;
exports.StyledToggleTextWrapper = styled_components_1.default.div `
  display: flex;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
//# sourceMappingURL=FontFamily.style.js.map